/**
 * @fileoverview GET handler for the "/engagement/sdk_auth/changelogs" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementSdkAuthChangelogs } from "./constants";
import type { SdkAuthChangelogResult } from "./types";

/**
 * fetches the changelog for `sdk_auth` objects
 * @note this is forked from the `/engagement/changelogs` endpoint because it returns a
 *   `key` property that is specific to SDK auth objects.
 */
export const getSdkAuthChangelogs = reactQueryFetcherAdapter(
  engagementSdkAuthChangelogs,
  (signal: AbortSignal, id: string): Promise<SdkAuthChangelogResult> => {
    return fetch("/engagement/sdk_auth/changelogs", "GET", { id, type: "sdk-auth" }, { signal });
  }
);
